import styled from "styled-components";
import Img from "../../../Img";
import colors from "../../../../../styles/colors";

export const Wrapper = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  cursor: pointer;
  @media (max-height: 900px) {
    width: 18px;
    height: 18px;
  }
  @media (max-height: 800px) {
    width: 15px;
    height: 15px;
  }
`;

export const Image = styled(Img)`
  display: flex;
  width: 100%;
  height: 100%;
  color: ${colors.blue3};
`;
